import axios from 'axios'
import { TokenService } from './token.service'

class ApiError extends Error {
    constructor(error) {
        super(error.response.statusText)
        this.name = this.constructor.name
        this.message = error.response.statusText || error.response.data
        this.errorCode = error.response.status
    }
}

class Confirm {
    constructor(confirm) {
        this.title = confirm ? confirm.title : undefined
        this.message = confirm ? confirm.message : undefined
        this.confirmButtonTitle = confirm ? confirm.confirmButtonTitle || 'Confirm' : 'Confirm'
        this.cancelButtonTitle = confirm ? confirm.cancelButtonTitle || 'Cancel' : 'Cancel'
    }
}

const ApiService = {

    init(baseUrl) {
        axios.defaults.baseURL = baseUrl
    },

    setHeader() {
        axios.defaults.headers.common['Authorization'] = `Bearer ${TokenService.getToken()}`
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) {
        this.setHeader()
        return axios.get(resource)
    },

    post(resource, data) {
        this.setHeader()
        return axios.post(resource, data)
    },

    put(resource, data) {
        this.setHeader()
        return axios.put(resource, data)
    },

    delete(resource) {
        this.setHeader()
        return axios.delete(resource)
    },

    customRequest(data) {
        this.setHeader()
        return axios(data)
    },

    postFile(endpoint, file){
        this.setHeader()
        let formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        return axios.post(endpoint, formData, config)
    },

    getFile(resource) {
        this.setHeader()
        const config = {
            responseType: 'blob',
        }
        return axios.get(resource, config)
    },
}

export { ApiService, ApiError, Confirm }